var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2114_6288)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9987 1.83398C4.59294 1.83398 1.83203 4.5949 1.83203 8.00065C1.83203 11.4064 4.59294 14.1673 7.9987 14.1673C11.4045 14.1673 14.1654 11.4064 14.1654 8.00065C14.1654 4.5949 11.4045 1.83398 7.9987 1.83398ZM0.832031 8.00065C0.832031 4.04261 4.04066 0.833984 7.9987 0.833984C11.9567 0.833984 15.1654 4.04261 15.1654 8.00065C15.1654 11.9587 11.9567 15.1673 7.9987 15.1673C4.04066 15.1673 0.832031 11.9587 0.832031 8.00065Z",
    fill: "#1275C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19547 8.16311C1.28984 7.9036 1.57672 7.76972 1.83624 7.86409L5.5029 9.19742C5.74958 9.28712 5.8849 9.5523 5.81279 9.80468L5.18862 11.9893L5.80637 13.8425C5.8937 14.1045 5.75212 14.3877 5.49015 14.475C5.22817 14.5623 4.94501 14.4207 4.85769 14.1588L4.19102 12.1588C4.15916 12.0632 4.15692 11.9602 4.1846 11.8633L4.72326 9.97798L1.49449 8.80388C1.23498 8.70951 1.1011 8.42263 1.19547 8.16311Z",
    fill: "#1275C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1739 7.85964C11.2426 7.83676 11.3153 7.82905 11.3872 7.83704L14.3872 8.17038C14.6617 8.20087 14.8595 8.44808 14.829 8.72253C14.7985 8.99699 14.5513 9.19476 14.2768 9.16426L11.386 8.84305L9.83203 9.36103V10.9955L11.1844 11.5364C11.3413 11.5992 11.4559 11.7369 11.489 11.9026L11.8223 13.5693C11.8765 13.84 11.7009 14.1035 11.4301 14.1576C11.1593 14.2118 10.8959 14.0362 10.8417 13.7654L10.5615 12.3643L9.14634 11.7982C8.95651 11.7223 8.83203 11.5384 8.83203 11.334V9.00065C8.83203 8.78544 8.96975 8.59437 9.17392 8.52631L11.1739 7.85964Z",
    fill: "#1275C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8235 3.19298C13.0855 3.2803 13.227 3.56346 13.1397 3.82543L12.8064 4.82543C12.7465 5.0051 12.5902 5.13551 12.4027 5.16229L10.4987 5.4343V6.26214L11.4797 5.86975C11.5387 5.84612 11.6018 5.83398 11.6654 5.83398H12.9987C13.0763 5.83398 13.1529 5.85206 13.2223 5.88677L14.5556 6.55344C14.8026 6.67693 14.9027 6.97727 14.7792 7.22426C14.6558 7.47125 14.3554 7.57136 14.1084 7.44787L12.8807 6.83399H11.7617L10.1844 7.46489C10.0303 7.52651 9.85577 7.5077 9.71838 7.41469C9.581 7.32167 9.4987 7.16656 9.4987 7.00065V5.00065C9.4987 4.75183 9.68166 4.54087 9.92799 4.50568L11.9554 4.21604L12.191 3.5092C12.2783 3.24723 12.5615 3.10565 12.8235 3.19298Z",
    fill: "#1275C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44176 1.55344C5.68875 1.42994 5.98908 1.53006 6.11258 1.77704L6.77925 3.11038C6.85949 3.27086 6.84759 3.46204 6.74806 3.61133L5.41472 5.61134C5.34117 5.72167 5.22679 5.79827 5.09676 5.82428L3.54938 6.13375L1.97771 7.39109C1.76208 7.56359 1.44744 7.52863 1.27493 7.313C1.10243 7.09737 1.13739 6.78272 1.35302 6.61022L3.01968 5.27688C3.0821 5.22695 3.15559 5.19271 3.23397 5.17703L4.69756 4.88431L5.75505 3.29806L5.21815 2.22426C5.09466 1.97727 5.19477 1.67693 5.44176 1.55344Z",
    fill: "#1275C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2114_6288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.17224a889077692f16f03a429b1e3f04.svg";
export { ForwardRef as ReactComponent };